import type { PageHelp } from '../network-help.data';

export const L10N_tr_g3: Record<string, PageHelp> = {
  'flights-search': {
    title: 'Uçuşlar',
    tag: 'Uçuş arama',
    tagline: 'Acentenin bilet kesebileceği her tedarikçiden uçuş rezervasyonu yapmaya yönelik satış noktası hunisi.',
    business: {
      lead: 'Uçuşlar, bir acentenin müşterinin seyahatini bir bilete dönüştürdüğü yerdir. Bu ekrandaki her sonuç kesilebilir niteliktedir — ya acentenin kendi SIGN’ı üzerinden ya da erişim verildiği bir partner SIGN aracılığıyla — dolayısıyla gösterilen ücretler, acentenin başka bir onay adımına gerek kalmadan gerçekten satabileceği ücretlerdir.',
      points: [
        { title: 'Birçok kanalda tek arama', desc: 'Tek bir sorgu, acentenin aktif olan her içerik kaynağına (kendi SIGN’ı, Partner Erişimi üzerinden ödünç alınan SIGN’lar, NDC/GDS beslemeleri) dağıtılır ve sonuçlar fiyata göre sıralanmış tek bir listede birleştirilir.' },
        { title: 'Katmanlı fiyatlandırma burada uygulanır', desc: 'Gösterilen fiyatlar, fiyatlandırma motorundan gelen Wholesale (SIGN sahibinin), Distribution (kanal) ve Retail (kendi) kâr paylarını halihazırda içerir — müşterinin gördüğü şey, acentenin talep etmeyi planladığı tutardır.' },
        { title: 'Önce yolcu, sonra ücret', desc: 'Yolcu tipleri (yetişkin / çocuk / bebek) ve seyahat tarihleri hem fiyatı hem de sonraki iade / yeniden rezervasyon uygunluğunu belirler, bu yüzden giriş formu önemlidir.' },
      ],
    },
    software: {
      lead: 'Gerçek bir müsaitlik API’sine bağlı, sonuçları fiyata ve kesecek SIGN’a göre gruplanmış bir ücret arama ekranı.',
      points: [
        { title: 'Sorguyu oluştur', desc: 'Kalkış, varış, tarihler ve yolcu sayıları aramayı yönlendirir; sınıf / havayolu / kabin ilk sonuç kümesinden sonra daraltılabilir.' },
        { title: 'Sonuç satırını oku', desc: 'Her satır ücreti, havayolunu, kabini ve biletin hangi SIGN üzerinden kesileceğini gösterir — sağdaki rozet.' },
        { title: 'Rezervasyona ilerle', desc: 'Bir ücret seçmek teklif detayını açar; oradan yolcu formu / koltuk haritası / ödeme akışı rezervasyonu bir rezervasyon kaydına dönüştürerek tamamlar.' },
      ],
    },
    flow: {
      lead: 'Müşteri talebinden kesilen bir bilete kadar uçtan uca yol.',
      steps: [
        { title: 'Seyahati gir', desc: 'Kalkış, varış, tek yön veya gidiş-dönüş, seyahat tarihleri ve yetişkin / çocuk / bebek sayıları.' },
        { title: 'Aramayı çalıştır', desc: 'Sonuçlar aktif olan her tedarikçiye dağıtılır ve fiyata göre sıralanmış tek bir listede birleştirilir.' },
        { title: 'Filtrele ve sırala', desc: 'Havayolu, kabin, aktarma ve kalkış saatine göre daralt; kesecek SIGN her satırda görünür.' },
        { title: 'Teklifi aç', desc: 'Teklif detayı ücret kurallarını, bagajı, iade ve yeniden rezervasyon politikasını gösterir — taahhüt etmeden önce bunları okuyun.' },
        { title: 'Yolcuları kaydet', desc: 'Her yolcu için yolcu formunu (ad, doğum tarihi, belge, sık uçan yolcu) doldurun; CRM seçici kayıtlı müşterilerden ön dolgu yapar.' },
        { title: 'Koltuk ve ek hizmetleri seç', desc: 'Koltuk haritası seçici ve ücretli ek hizmetler (bagaj, yemek) teklif üzerinde isteğe bağlı eklentilerdir.' },
        { title: 'Öde ve kes', desc: 'Ödeme, acentenin cüzdanı / kredi limiti üzerinden alınır; PNR rezerve edilir ve e-bilet kesilir.' },
      ],
    },
    modes: {
      lead: 'Bir uçuş teklifi üç tedarik modundan biri aracılığıyla karşılanır — her sonuçtaki rozet hangisini aldığınızı söyler.',
      modes: [
        { name: 'Own SIGN', when: 'acentenin doğrudan BSP / GDS kimlik bilgileri var', desc: 'Acente bileti kendi SIGN’ı üzerinden kesilir. Tam komisyon payı, en hızlı kesim, havayolu ile en sıkı destek döngüsü.' },
        { name: 'Partner SIGN', when: 'acente başka bir acentenin yetkisini kullanır', desc: 'Partner Erişimi üzerinden verilen bir SIGN üzerinden kesilir. Fiyatlandırma motorunun Wholesale katmanı SIGN sahibinin kâr payını alır.' },
        { name: 'NDC / bağlı', when: 'o havayolu için BSP ilişkisi yok', desc: 'Ücret bir NDC veya toplayıcı beslemesinden gelir. Kurallar GDS içeriğinden farklı olabilir (iadeler bağlayıcı tarafından yönetilir, koltuk haritası sınırlı olabilir).' },
      ],
    },
    examples: [
      {
        title: 'Bir DXB → LHR business gidiş-dönüş · 2 yetişkin · own SIGN',
        rows: [
          { label: 'Baz ücret (yolcu başına) × 2', value: '28,000,000' },
          { label: 'Vergiler & YQ', value: '4,200,000' },
          { label: 'Wholesale MARKUP · uygulanamaz (own SIGN)', value: '0' },
          { label: 'Retail MARKUP · brütün +%5’i', value: '+1,610,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '33,810,000', strong: true },
        ],
        note: 'Own-SIGN kesimi Wholesale katmanını tamamen atlar — SIGN sahibi satıcının kendisidir, dolayısıyla ödenecek bir yeniden satıcı marjı yoktur.',
      },
      {
        title: 'Aynı seyahat · ödünç alınan partner SIGN',
        rows: [
          { label: 'Baz ücret + vergiler', value: '32,200,000' },
          { label: 'Wholesale MARKUP · +%4 (partnerin payı)', value: '+1,288,000', accent: 'info' },
          { label: 'Retail MARKUP · brütün +%5’i', value: '+1,674,400', accent: 'success' },
          { label: 'Yolcu toplamı', value: '35,162,400', strong: true },
        ],
        note: 'Wholesale katmanı, SIGN yetkisi için partner acenteye ödeme yapar. Ardından Retail yeni yürüyen toplam üzerinden hesaplanır.',
      },
    ],
    related: ['hotels-search', 'markup', 'signs', 'partner-access'],
  },

  'hotels-search': {
    title: 'Oteller',
    tag: 'Otel arama',
    tagline: 'Kendi envanteri ve bağlı tedarikçiler arasında otel konaklamaları için ara-ve-rezerve akışı.',
    business: {
      lead: 'Oteller, bir acentenin oda ister acentenin kendi sözleşmeli envanterinden, ister bir yetki aracılığıyla paylaşılan partner envanterinden, ister bağlı harici bir tedarikçiden gelsin bir konaklama satmasını sağlar. İki satış modu bir arada bulunur: Anında (operatör önceden onaylar) ve Talep Üzerine (operatör bir tedarikçi onaylayana kadar talebi bekletir) ve ekran her sonuca hangi modun uygulandığını netleştirir.',
      points: [
        { title: 'Kendi vs bağlı tedarik', desc: 'Kendi sözleşmeli odalar platformun Otel Tesisi modülünde bulunur; bağlı tedarik harici sağlayıcılardan gelir. Motor her ikisini tek bir sonuç kümesinde birleştirir.' },
        { title: 'Anında veya Talep Üzerine', desc: 'Anında sonuçlar rezervasyon anında onaylanır; Talep Üzerine sonuçları operatör (veya tedarikçi) kabul edene kadar teklif edilir ve bekletilir — iş akışı bu karardan itibaren ayrışır.' },
        { title: 'Gecelik fiyatlandırma = katmanlı fiyatlandırma', desc: 'Gösterilen gecelik fiyat, fiyatlandırma motorunun Wholesale / Distribution / Retail katmanlarını halihazırda içerir; blanket gece başı indirimler (ör. konaklama süresine dayalı) da uygulanabilir.' },
      ],
    },
    software: {
      lead: 'Oda / ücret planı sonuçları ve hemen-rezerve / rezervasyon-talep et ayrımı olan bir destinasyon arama ekranı.',
      points: [
        { title: 'Destinasyon + tarihe göre ara', desc: 'Şehir, giriş / çıkış ve odalar birincil aramayı yönlendirir; filtreler (yıldız derecesi, pansiyon, zincir) sonuçları daraltır.' },
        { title: 'Mod rozetini oku', desc: 'Her tesis kutucuğu bir Anında veya Talep Üzerine rozeti taşır, böylece operatör taahhüt etmeden önce satış modu görünür olur.' },
        { title: 'Rezerve etmeye veya talep etmeye devam et', desc: 'Bir oda seçmek Anında için misafir formu ve ödeme akışına ilerler; Talep Üzerine için ise operatör onaylayana kadar bekleyen bir rezervasyona dönüşen bir talep formu açar.' },
      ],
    },
    flow: {
      lead: '“Gelecek hafta Dubai’de bir odaya ihtiyacım var” ifadesinden onaylanmış bir rezervasyona (veya bekletilen bir talebe) kadar.',
      steps: [
        { title: 'Konaklamayı gir', desc: 'Destinasyon şehri, giriş / çıkış tarihleri, oda sayısı ve misafir sayıları.' },
        { title: 'Aramayı çalıştır', desc: 'Sonuçlar kendi sözleşmeli odaları ve bağlı tedarikçi beslemelerini fiyata göre sıralanmış tek bir listede birleştirir.' },
        { title: 'Tesisleri filtrele', desc: 'Yıldız derecesi, pansiyon tipi, zincir, merkeze uzaklık ve fiyat aralığına göre daralt; her kutucuk bir Anında veya Talep Üzerine rozeti gösterir.' },
        { title: 'Tesisi aç', desc: 'Oda tipleri, ücret planları, iptal politikası, pansiyon ve dahil olanların tümü tesis detay ekranındadır.' },
        { title: 'Bir ücret planı seç', desc: 'Hangi ücret planının rezerve edileceğini (Sadece Oda, B&B, Yarım Pansiyon, İade Edilemez) ve sonuçta oluşan gecelik fiyatı seçin.' },
        { title: 'Misafirleri kaydet + öde', desc: 'Anında için misafir formu + ödeme. Talep Üzerine için, talebi gönderin — rezervasyon onay beklerken bekletilir.' },
        { title: 'Voucher’ı al', desc: 'Onaylandıktan sonra, otel voucher’ı ve tedarikçi onayı rezervasyon kaydına eklenir.' },
      ],
    },
    modes: {
      lead: 'Her sonuçtaki Anında / Talep Üzerine rozeti, operatöre rezervasyonun nasıl onaylanacağını ve paranın ne zaman hareket edeceğini söyler.',
      modes: [
        { name: 'Anında', when: 'gerçek zamanlı müsaitliği olan kendi envanteri veya bağlı tedarikçi', desc: 'Rezervasyon tıklama anında onaylanır. Ödeme hemen alınır. Voucher hemen ardından kesilir. Kontenjan anında düşülür.' },
        { name: 'Talep Üzerine', when: 'gerçek zamanlı müsaitliği olmayan harici tedarikçi veya kontenjan dışı sorgu', desc: 'Rezervasyon, operatör (veya tedarikçi) kabul edene kadar bekleyen bir talep olarak bekletilir. Onaya kadar kontenjandan hiçbir şey düşülmez; ödeme talep anında değil, onay anında alınır.' },
        { name: 'Kendi envanteri', when: 'acentenin doğrudan sözleşmeleri var', desc: 'Odalar platformun Otel Tesisi modülünden sağlanır. Kontenjan, ücret planları ve iptal politikaları acentenin kendisi tarafından yönetilir.' },
        { name: 'Bağlı tedarik', when: 'harici tedarikçi beslemesi', desc: 'Odalar bir partner API’sinden (bedbank, toplayıcı) gelir. Politikalar + iade akışı acentenin değil, tedarikçinin sözleşmesini izler.' },
      ],
    },
    examples: [
      {
        title: '3 gecelik konaklama · 1 oda · 2 misafir · Yarım Pansiyon · Anında',
        rows: [
          { label: 'Gecelik ücret × 3 gece', value: '9,000,000' },
          { label: 'Wholesale MARKUP · +%3 (tedarikçi marjı)', value: '+270,000', accent: 'info' },
          { label: 'Retail MARKUP · brütün +%6’sı', value: '+556,200', accent: 'success' },
          { label: 'Yolcu toplamı', value: '9,826,200', strong: true },
        ],
        note: 'Anında hemen onaylanır; ücret planındaki kontenjan 3 gecenin her biri için 1 oda-gece düşer.',
      },
      {
        title: 'Aynı konaklama · Talep Üzerine',
        rows: [
          { label: 'Teklif edilen toplam (bekletilir, tahsil edilmez)', value: '9,826,200' },
          { label: 'Onaylandığında', value: 'ödeme alınır', accent: 'success' },
          { label: 'Reddedildiğinde', value: 'hiçbir şey tahsil edilmez', accent: 'info' },
        ],
        note: 'Talep Üzerine teklifleri fiyatı SLA penceresi boyunca kilitler. Tedarikçi bu pencere içinde onaylayamazsa, talep otomatik olarak zaman aşımına uğrar.',
      },
    ],
    related: ['tours', 'markup', 'reference-data'],
  },

  tours: {
    title: 'Turlar',
    tag: 'Tur paketleri',
    tagline: 'Rezerve edilebilir çok hizmetli paketler — otel + uçuş + aktiviteler — tek bir satır olarak satılır.',
    business: {
      lead: 'Turlar bir paketi (otel + uçuş + isteğe bağlı transferler, yemekler, aktiviteler) tek bir satılabilir ürüne dönüştürür. Ticari değer, paketlenmiş marjdır: operatör paketi belirli bir talep koridoruna (kurumsal ekipler, hac ziyaretleri, aile tatilleri) yönelik fiyatlandırabilir, bileşen başına ücretleri tek tek ifşa etmeden.',
      points: [
        { title: 'Tek SKU, birçok bileşen', desc: 'Bir tur paketi, uçuşları, odaları ve hizmetleri bir araya getirse bile tek bir rezerve edilebilir kayıttır; bu, gelir atfını ve iptali bileşenleri ayrı ayrı satmaktan daha temiz hale getirir.' },
        { title: 'Kalkışlar ve envanter', desc: 'Bir paket, sabit bir kapasiteyle belirli kalkış tarihlerinde sunulur; tükenen tarihler otomatik olarak sonuçların dışında kalır.' },
        { title: 'Aynı fiyatlandırma motoru', desc: 'Katmanlı fiyatlandırma yine geçerlidir — bir tur Wholesale / Distribution / Retail kural yığınından muaf değildir.' },
      ],
    },
    software: {
      lead: 'Tur kataloğuyla desteklenen, kalkış tarihi ve dahil olanlar filtreleriyle bir paket arama ekranı.',
      points: [
        { title: 'Bir paket bul', desc: 'Destinasyon, kalkış penceresi ve yolcu sayıları sonuçları yönlendirir; kategori ve dahil olanlar filtreleri daha da daraltır.' },
        { title: 'Paketi incele', desc: 'Bir paket seçmek, bir kalkış tarihine taahhüt etmeden önce tam güzergâhını ve dahil olanlar listesini açar.' },
        { title: 'Bir kalkışa rezerve et', desc: 'Bir tarih seçin, yolcuları tur kayıt çekmecesi aracılığıyla kaydedin ve ödemeyi tamamlayın — sonuç, bileşen başına bir tane değil, tek bir tur rezervasyonudur.' },
      ],
    },
    flow: {
      lead: '“Ekimde bir Gürcistan gezisi istiyoruz” ifadesinden belirli bir kalkışta onaylanmış bir pakete kadar.',
      steps: [
        { title: 'Seyahati gir', desc: 'Destinasyon ülkesi / bölgesi, kalkış ayı, yetişkin / çocuk / bebek sayıları.' },
        { title: 'Sonuçlara göz at', desc: 'Kartlar paket başlığını, süresini, öne çıkan dahil olanları ve en ucuz kalkış için başlangıç fiyatını gösterir.' },
        { title: 'Paketi aç', desc: 'Detay ekranı gün gün güzergâhı, dahil olanları, hariç tutulanları, otel + uçuş bileşenlerini ve iptal politikasını gösterir.' },
        { title: 'Bir kalkış seç', desc: 'Kalkış takvimi, tarih başına fiyatlar ve kalan koltuklarla birlikte müsait tarihleri gösterir; tükenen tarihler soluklaştırılır.' },
        { title: 'Yolcuları kaydet', desc: 'Tur kayıt çekmecesi her yolcunun belgesini, yemeğini, oda paylaşımı tercihini ve varsa aktivite katılımını toplar.' },
        { title: 'Öde ve onayla', desc: 'Tek bir ödeme paketi kapatır. Tüm bileşen voucher’ları (uçuş, otel, aktiviteler) tek tur rezervasyonuna eklenir.' },
      ],
    },
    modes: {
      lead: 'Turlar iki dik eksende kataloglanır — gezi uzunluğu ve kalkış modeli.',
      modes: [
        { name: 'Sabit kalkış', when: 'belirli tarih ve kapasiteli grup turu', desc: 'Tüm grup önceden belirlenmiş tarihlerde birlikte uçar ve konaklar. Kalkışlar kapasiteye ulaşana kadar dolar, sonra kapanır.' },
        { name: 'Özel / talep üzerine', when: 'kendi tarihlerini isteyen bağımsız yolcu', desc: 'Paket çerçevesi (oteller, transferler, aktiviteler) yeniden kullanılır ancak uçuşlar ve güzergâh yolcunun tarihlerine kayar.' },
        { name: 'Sadece kara', when: 'uçuş başka yerde rezerve edilir', desc: 'Uçuş bileşeni olmadan otel + transferler + aktiviteler — daha düşük fiyatlandırılır ve yolcu kendi biletini getirir.' },
        { name: 'Tam paket', when: 'varsayılan', desc: 'Uçuş + otel + transferler + aktiviteler tek fiyat olarak. Rezervasyon başına en yüksek marj, ilk kez seyahat eden birine satması en basit.' },
      ],
    },
    examples: [
      {
        title: 'Gürcistan 5 günlük paket · 2 yetişkin · Tam paket',
        rows: [
          { label: 'Uçuş bileşeni (2 yolcu)', value: '12,000,000' },
          { label: 'Otel bileşeni (4 gece × 2 yolcu)', value: '18,000,000' },
          { label: 'Transferler + aktiviteler', value: '5,000,000' },
          { label: 'Baz paket maliyeti', value: '35,000,000' },
          { label: 'Wholesale MARKUP · +%5', value: '+1,750,000', accent: 'info' },
          { label: 'Retail MARKUP · brütün +%8’i', value: '+2,940,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '39,690,000', strong: true },
        ],
        note: 'Tek bir paket maliyeti bileşen ücretlerini müşteriden gizler — operatör üç ayrı satır kalemini savunmak yerine bir başlık fiyatı pazarlar.',
      },
    ],
    related: ['hotels-search', 'flights-search', 'markup'],
  },

  'trains-search': {
    title: 'Trenler',
    tag: 'Demiryolu arama',
    tagline: 'Bağlı demiryolu operatörleri genelinde tren yolculukları için ara-ve-rezerve.',
    business: {
      lead: 'Trenler, iç hat ve kısa mesafe koridorlarında demiryolunu uçuşlara alternatif veya tamamlayıcı olarak satar. Demiryolunun ticari şekli havadan farklıdır (istasyondan istasyona, kabine değil sınıfa dayalı, daha sıkı iptal kuralları) ve ekran bu farkları açıkça gösterir, böylece bir seyahat için teklif veren bir acente, gezi uzunluğuna uygun ürünü seçer.',
      points: [
        { title: 'Farklı fiyatlandırma ritmi', desc: 'Demiryolu ücretleri uçuşlar gibi dakika dakika dalgalanmaz; statik tarifeler, aynı ücretin genellikle saatlerce mevcut olduğu anlamına gelir, dolayısıyla teklifler daha istikrarlıdır.' },
        { title: 'Sınıf havayolundan daha önemlidir', desc: 'Seçim, rakip taşıyıcılar arasında değil, aynı trende ekonomi / birinci / business sınıf arasındadır — alıcının karar ekseni farklıdır.' },
        { title: 'Rezerveli vs açık biletler', desc: 'Bazı rotalar koltuk rezervasyonu gerektirir, diğerleri açık biletleri kabul eder; akış operatöre göre uyarlanır.' },
      ],
    },
    software: {
      lead: 'Yolculuk / sınıf / operatör filtreleriyle istasyondan istasyona bir arama.',
      points: [
        { title: 'Yolculuğu oluştur', desc: 'Kalkış ve varış istasyonları, kalkış tarihi ve yolcu sayısı aramayı yönlendirir.' },
        { title: 'Yolculuk satırını oku', desc: 'Her sonuç operatörü, sınıf seçeneklerini ve sınıf başına ücreti gösterir; aktarma süresi ve duraklar satırdadır.' },
        { title: 'Rezervasyona ilerle', desc: 'Bir ücret seçmek yolcu formu / koltuk seçimi akışını, ardından ödemeyi açar; sonuçta oluşan rezervasyon diğer herhangi bir rezervasyon gibi davranır.' },
      ],
    },
    flow: {
      lead: 'Bir demiryolu rezervasyonunun bir uçuştan daha az hareketli parçası vardır — ancak koltuk rezervasyonu ve sınıf seçimi kabin seçiminin yerini alır.',
      steps: [
        { title: 'İstasyonları seç', desc: 'Kalkış ve varış istasyonları (şehirler değil — bir şehrin birkaç istasyonu olabilir ve doğru olanı seçmek yolcuya bir taksi tasarrufu sağlar).' },
        { title: 'Tarihi seç', desc: 'Demiryolu fiyat açısından havadan çok daha az tarihe duyarlıdır; aynı ücret genellikle tüm işletme günü boyunca tutulur.' },
        { title: 'Yolculuk listesini oku', desc: 'Günün kalkışları süre, duraklar, sınıf seçenekleri ve sınıf başına fiyatla listelenir.' },
        { title: 'Bir sınıf seç', desc: 'Ekonomi, birinci veya business koltuk konforunu ve (bazı operatörlerde) yemek / lounge dahilliğini değiştirir.' },
        { title: 'Bir koltuk rezerve et', desc: 'Rezervasyon gerektiren operatörlerde, koltuk haritası seçici sınıf seçiminden sonra açılır; açık biletli operatörler bu adımı atlar.' },
        { title: 'Yolcuları kaydet + öde', desc: 'Standart yolcu formu + ödeme; e-bilet / QR rezervasyona eklenir.' },
      ],
    },
    modes: {
      lead: 'Demiryolu ücretleri iki eksende havadan ayrışır — biletin belirli bir koltuğa bağlı olup olmadığı ve sınıfın size gerçekte ne satın aldığı.',
      modes: [
        { name: 'Rezerveli koltuk', when: 'yüksek hızlı / uzun mesafe operatörleri', desc: 'Bilet belirli bir tren ve koltuğa bağlıdır. Treni kaçırırsanız bilet geçersiz olur (veya yeniden rezervasyon ücretine tabidir). Rezervasyonda koltuk haritası mevcuttur.' },
        { name: 'Açık bilet', when: 'banliyö / kısa mesafe rotaları', desc: 'Bir geçerlilik penceresi içinde (genellikle seyahat günü) bir sınıfın herhangi bir treninde geçerlidir. Koltuk haritası yok — sınıf vagonunda ilk gelen ilk oturur.' },
        { name: 'Ekonomi sınıf', when: 'varsayılan fiyat noktası', desc: 'Standart oturma, ek dahiliyet yok. Demiryolu rezervasyonlarının büyük kısmı.' },
        { name: 'Birinci sınıf', when: 'iş seyahati yapanlar', desc: 'Daha geniş koltuk aralığı, daha sessiz vagon, bazen hafif bir yemek veya lounge erişimi.' },
        { name: 'Business sınıf', when: 'premium uzun mesafe', desc: 'Yalnızca bazı operatörlerde. Masalı koltuk, prizli, öncelikli biniş, tam yemek servisi.' },
      ],
    },
    examples: [
      {
        title: 'Tahran → Meşhed · gece · 1. sınıf · 2 yolcu',
        rows: [
          { label: 'Baz ücret (yolcu başına) × 2', value: '3,200,000' },
          { label: 'Retail MARKUP · +%5', value: '+160,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '3,360,000', strong: true },
        ],
        note: 'Demiryolu genellikle Wholesale katmanını atlar — operatör yayınlanan ücretten satar ve acentenin tek marjı Retail’dir.',
      },
    ],
    related: ['buses-search', 'flights-search', 'markup'],
  },

  'buses-search': {
    title: 'Otobüsler',
    tag: 'Otobüs arama',
    tagline: 'Kara ulaşımının fiyat veya erişimde kazandığı koridorlar için uzun mesafe otobüs rotaları.',
    business: {
      lead: 'Otobüsler, bir otobüsün ya tek gerçekçi seçenek olduğu ya da havadan / demiryolundan açıkça daha ucuz olduğu koridorları kapsar. Ticari rolü kapsamdır: acentenin, rotası havaalanı veya tren istasyonu olmayan kasabalara dokunan bir müşteri için tam bir seyahati uçtan uca rezerve etmesini sağlar.',
      points: [
        { title: 'Hızdan çok kapsam', desc: 'Otobüsler uçuşların ve demiryolunun ulaşmadığı şehirlere ve kasabalara ulaşır — hac, bölgesel iş seyahati ve son kilometre bağlantıları için kritik.' },
        { title: 'Basit, nakit dostu ücretler', desc: 'Otobüs ücretleri genellikle daha az markalı sınıfla koltuk başına sabittir, bu da toplu / kurumsal teklif vermeyi kolaylaştırır.' },
        { title: 'Daha az tedarikçi hareketli parçası', desc: 'Çoğu operatör dinamik müsaitlik yerine statik bir tarife sunar, dolayısıyla arama sonuçları gün boyunca istikrarlıdır.' },
      ],
    },
    software: {
      lead: 'Operatör / koltuk sınıfı filtreleriyle şehirden şehre bir arama, şu anda backend entegrasyonu beklenirken park edilmiş durumda.',
      points: [
        { title: 'Seyahati oluştur', desc: 'Kalkış ve varış şehirleri, kalkış tarihi ve yolcu sayısı aramayı yönlendirir.' },
        { title: 'Rota satırını oku', desc: 'Her sonuç operatörü, süreyi ve fiyatı gösterir; koltuk sınıfı seçenekleri seçimde açılır.' },
        { title: 'Rezervasyona ilerle', desc: 'Seçilen bir koltuk yolcu ve ödeme akışını açar; kayıt diğer her ürün gibi Tüm Rezervasyonlara katılır.' },
      ],
    },
    flow: {
      lead: 'Bir otobüs rezervasyonu en basit ulaşım akışıdır — sabit bir tarife, rota başına tek bir koltuk sınıfı (genellikle) ve koltuk başına tek bir sabit ücret.',
      steps: [
        { title: 'Kalkış + varış seç', desc: 'Şehirler (istasyonlar değil — operatörün genellikle şehir başına bir terminali vardır).' },
        { title: 'Tarihi seç', desc: 'Tüm günün tarifesi yüklenir — ücretler gün boyunca dalgalanmaz.' },
        { title: 'Bir kalkış seç', desc: 'Her satır bir kalkıştır: operatör, koltuk sınıfı, fiyat ve tahmini seyahat süresi.' },
        { title: 'Bir koltuk seç', desc: 'Destekleyen operatörlerde bir koltuk haritası açılır; aksi halde bilet biniş sırasında atanır.' },
        { title: 'Yolcuları kaydet + öde', desc: 'Standart yolcu formu + ödeme; QR / e-bilet rezervasyona eklenir.' },
      ],
    },
    modes: {
      lead: 'Otobüs operatörleri çoğunlukla tek bir hizmet sınıfı sunar, ancak koltuk seçimi deneyimi değişir.',
      modes: [
        { name: 'Atanmış koltuk', when: 'koltuk haritası olan operatörler', desc: 'Rezervasyonda belirli bir koltuk seçin. E-bilet koltuk numarasını taşır ve biniş operatörü bunu uygular.' },
        { name: 'Açık oturma', when: 'koltuk haritası olmayan operatörler', desc: 'Koltuk biniş sırasında talep edilir. E-bilet yalnızca o kalkışta bir yer garantiler.' },
        { name: 'VIP sınıf', when: 'premium uzun mesafe rotaları', desc: 'Daha geniş koltuklar, bazen standart 2+2 yerine 3’lü oturma (2+1), bazı operatörlerde hafif ikramlar içerir.' },
        { name: 'Standart sınıf', when: 'varsayılan', desc: 'Standart otobüs oturması, ek dahiliyet yok. En ucuz ve en yaygın.' },
      ],
    },
    examples: [
      {
        title: 'Tahran → İsfahan · VIP sınıf · 2 yolcu',
        rows: [
          { label: 'Baz ücret (yolcu başına) × 2', value: '1,600,000' },
          { label: 'Retail MARKUP · +%6', value: '+96,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '1,696,000', strong: true },
        ],
        note: 'Otobüs ince marjlı bir üründür — Sadece-Retail fiyatlandırma normdur; operatör ücreti yayınlar, acentenin payı Retail’de eklenir.',
      },
    ],
    related: ['trains-search', 'ground', 'markup'],
  },

  // ── Flights funnel (search → results → passengers → seats → payment → ticket, + manual) ──
  'flights-results': {
    title: 'Uçuş Sonuçları',
    tag: 'Uçuş arama',
    tagline: 'Seyahat için kesilebilir her ücret, birleştirilmiş ve sıralanmış — kesecek olanı seçin.',
    business: {
      lead: 'Sonuçlar ekranı, bir teklifin bir seçime dönüştüğü yerdir. Her satır acentenin gerçekten kesebileceği bir ücrettir (own SIGN veya bir partner SIGN), gösterilen fiyat halihazırda Wholesale / Distribution / Retail kâr paylarını taşır ve kesecek SIGN görünürdür, böylece acente taahhüt etmeden önce biletin nasıl karşılanacağını bilir.',
      points: [
        { title: 'Tek birleştirilmiş, sıralanmış liste', desc: 'Aktif olan her tedarikçiden gelen ücretler birleştirilir ve fiyata göre sıralanır, böylece acente kanallar arasında sekme değiştirmek yerine benzeri benzeriyle karşılaştırır.' },
        { title: 'Fiyat her şey dahildir', desc: 'Satırda görünen şey yolcunun ödediği şeydir — fiyatlandırma motorunun katmanları halihazırda uygulanmıştır.' },
        { title: 'Önemli olanda karşılaştır', desc: 'Bagaj, iade edilebilirlik, aktarmalar ve kalkış saati kararı en az başlık fiyatı kadar yönlendirir.' },
      ],
    },
    software: {
      lead: 'Tarihe göre en ucuz ücret şeridi olan filtrelenebilir, sıralanabilir bir ücret listesi.',
      points: [
        { title: 'Filtrele ve sırala', desc: 'Kenar çubuğu aktarmalara, fiyat aralığına, havayollarına, kalkış / varış saatine, ücret tipine ve kaynağa göre daraltır.' },
        { title: 'Ücret şeridini tara', desc: 'Bir mini takvim tarih ±7 gün için tarih başına en ucuz ücreti gösterir; aramayı yeniden çalıştırmak için bir tarihe tıklayın.' },
        { title: 'Satırı oku, sonra seç', desc: 'Her kart segment güzergâhını, bagaj etiketlerini ve (ara-ve-rezerve) net / marj / komisyonu gösterir; bir ücret seçmek yolcu başına bölünmesini yolcu adımına taşır.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'markup'],
  },

  'flights-manual': {
    title: 'Uçuş Manuel Giriş',
    tag: 'Kanal dışı bilet',
    tagline: 'Platform dışında rezerve edilen bir uçuşu kaydedin, böylece diğer herhangi biri gibi sipariş defterinde yaşasın.',
    business: {
      lead: 'Her bilet arama hunisinden gelmez — bazıları doğrudan bir havayolu ile, bir konsolidatör aracılığıyla veya telefonla kesilir. Manuel giriş bunları yakalar, böylece rezervasyon, yolcuları ve parası çevrimiçi satışlarla birlikte izlenir, faturalandırılır ve raporlanır.',
      points: [
        { title: 'Tek sipariş defteri', desc: 'Sistem dışı satılan hiçbir şey görünmez kalmaz — bir manuel bilet diğer herhangi bir sipariş gibi Tüm Rezervasyonlara katılır.' },
        { title: 'Marj yine raporlanır', desc: 'Tam ücret dökümü (baz, vergiler, ücretler, kâr payı, komisyon) yakalanır, böylece kâr raporlaması eksiksiz kalır.' },
        { title: 'Çok bacaklı destekli', desc: 'Tek yön, gidiş-dönüş ve çok şehirli güzergâhların tümü girilebilir, yolcu başına bacak başına bir e-bilet ile.' },
      ],
    },
    software: {
      lead: 'Güzergâhı, tedarikçiyi ve yolcu başına e-biletleri girmek için yapılandırılmış bir form.',
      points: [
        { title: 'Güzergâhı oluştur', desc: 'Seyahat tipi artı bacak kartları — kalkış / varış havaalanları, havayolu, saatler, uçak, kabin ve koltuk.' },
        { title: 'Kaynak ve parayı ayarla', desc: 'Rezervasyon kaynağı / tedarikçi, tur kodu ve para birimi, bacak başına ücret dökümüyle.' },
        { title: 'Biletleri ata, sonra devam et', desc: 'Yolcu başına bir e-bilet bacaklara atanır; yolcu adımına devam edin.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'bookings'],
  },

  'flights-passengers': {
    title: 'Uçuş Yolcuları',
    tag: 'Yolcu detayları',
    tagline: 'Her yolcuyu adlandırın, ücret kademesini seçin ve havayolunun bilet kesmek için ihtiyaç duyduğu detayları yakalayın.',
    business: {
      lead: 'Yolcu adımı, bir teklifin adlandırılmış, biletlenebilir bir rezervasyona dönüştüğü yerdir. Burada girilen belge ve iletişim detayları, havayolunun kesimde ve sınırın seyahatte doğruladığı şeydir — bunları ilk seferde doğru yapmak maliyetli yeniden kesimlerden kaçınır.',
      points: [
        { title: 'Ücret kademesi ticari bir seçimdir', desc: 'Saver / Flex / Plus fiyatı bagaj, iade edilebilirlik, koltuk ve yemeğe karşı takas eder — acente yolcuya uygun kademeyi seçer.' },
        { title: 'Pasaport verisi zorunludur', desc: 'Ad, doğum tarihi, uyruk, pasaport numarası ve son kullanma tarihi havayolunun biletleme girdileridir, isteğe bağlı ekler değil.' },
        { title: 'CRM ön dolgusu tuş vuruşlarından tasarruf sağlar', desc: 'Kayıtlı bir müşteri seçmek, onların yolcularını CRM’den otomatik doldurur, böylece geri dönen bir yolcu bir kez girilir ve yeniden kullanılır.' },
      ],
    },
    software: {
      lead: 'Bir ücret kademesi ızgarası artı yolcu başına bir kimlik kartı ve seyahat geneli bir iletişim bloğu.',
      points: [
        { title: 'Ücret kademesini seç', desc: 'Bir ızgara kademeleri bagaj, iade, koltuk, yemek ve sık uçan yolcu kazanımına göre karşılaştırır.' },
        { title: 'Her yolcu kartını doldur', desc: 'Unvan, ad, doğum tarihi, uyruk, sık uçan yolcu numarası, pasaport ve son kullanma tarihi, artı yemek / koltuk SSR etiketleri.' },
        { title: 'İletişim ekle, sonra devam et', desc: 'Rezervasyon için e-posta ve arama kodlu telefon; isteğe bağlı koltuk seçimine veya doğrudan ödemeye devam edin.' },
      ],
    },
    related: ['flights-results', 'flights-seats', 'flights-payment', 'customers'],
  },

  'flights-seats': {
    title: 'Koltuk Seçimi',
    tag: 'İsteğe bağlı eklenti',
    tagline: 'İnteraktif bir haritada koltuk atayın — veya atlayın ve havayolunun tahsis etmesine izin verin.',
    business: {
      lead: 'Koltuk seçimi isteğe bağlı, genellikle ücretli bir ek hizmettir. Koltukları önceden seçmek yolcunun deneyimini iyileştirir ve harita ücretli olduğunda marj ekleyebilir; atlamak tahsisi ücretsiz olarak check-in’de havayoluna bırakır. Her iki durumda da rezervasyon devam eder.',
      points: [
        { title: 'Her zaman isteğe bağlı', desc: 'Atlayın ve havayolu koltukları check-in’de tahsis eder — rezervasyon bu adımda asla bloke edilmez.' },
        { title: 'Ücretli vs ücretsiz değişir', desc: 'Standart, tercihli ve ekstra bacak mesafeli koltuklar ücrete ve taşıyıcıya bağlı olarak farklı ücretler taşıyabilir.' },
        { title: 'Yolcu başına', desc: 'Rezervasyondaki her yolcuya kendi koltuğu atanır.' },
      ],
    },
    software: {
      lead: 'Uçak için oluşturulmuş bir koltuk haritası, bir yolcu kenar çubuğu ve yürüyen bir atama sayacı ile.',
      points: [
        { title: 'Haritayı oku', desc: 'Izgara, uçak düzeni için mevcut, dolu ve seçilmiş koltukları gösterir.' },
        { title: 'Her yolcuyu ata', desc: 'Kenar çubuğundan yolcu başına bir koltuk seçin; alt bilgi kaç tanesinin atandığını izler.' },
        { title: 'Atla veya devam et', desc: 'Atamaları kaydedin veya atlayın; her ikisi de ödemeye ilerler. (Aynı koltuk haritası otobüslere de hizmet eder.)' },
      ],
    },
    related: ['flights-passengers', 'flights-payment'],
  },

  'flights-payment': {
    title: 'Uçuş Ödemesi',
    tag: 'Tahsil & kesim',
    tagline: 'Rezervasyonun nasıl ödeneceğini seçin, sonra bileti kesin.',
    business: {
      lead: 'Ödeme, paranın taahhüt edildiği ve biletin kesildiği yerdir. Yöntem, fonların nasıl hareket edeceğine karar verir — acente cüzdanından veya kredi limitinden anında ya da acentenin kaydettiği bir kart / gateway / POS / banka havalesi aracılığıyla — ve sipariş özeti, taahhüt etmeden önce acenteye marjını ve komisyonunu gösterir.',
      points: [
        { title: 'Cüzdan ve kredi anındadır', desc: 'Her ikisi de acente hesabından çeker, böylece bilet harici bir kanalı beklemeden kesilebilir.' },
        { title: 'İran kanalları desteklenir', desc: 'IPG (Shaparak / ZarinPal ve emsalleri), POS kart okuyucu, Sheba banka havalesi ve 3DS kartın tümü birinci sınıf yöntemlerdir.' },
        { title: 'Marj kesimden önce görünür', desc: 'Ara-ve-rezervede özet net / kâr payı / komisyonu gösterir, böylece acente gözü açık taahhüt eder.' },
      ],
    },
    software: {
      lead: 'Yönteme özel alanlar ve bir sipariş-özeti kenar çubuğu olan bir ödeme yöntemi seçici.',
      points: [
        { title: 'Yöntemi seç', desc: 'Cüzdan, kredi limiti, müşteri kartı, nakit, IPG, POS veya banka havalesi — her biri bir radyo kartı.' },
        { title: 'Yöntemin formunu doldur', desc: 'Kart 3DS; IPG gateway + telefon + referans; POS terminal / RRN / iz; Sheba kaynak & hedef IBAN + referans.' },
        { title: 'Fatura ekle, sonra kes', desc: 'Fatura bloğunda fatura edilecek, VAT ve PO detayları; “Öde ve kes” siparişi oluşturur ve bilete geçer.' },
      ],
    },
    modes: {
      lead: 'Aynı ödeme yöntemleri ürünler genelinde mevcuttur — seçim, paranın nasıl ve ne zaman uzlaştığıyla ilgilidir.',
      modes: [
        { name: 'Cüzdan', when: 'varsayılan / önerilen', desc: 'Acentenin ön ödemeli bakiyesinden gerçek zamanlı olarak borçlandırılır. Kesime en hızlı yol; harici adım yok.' },
        { name: 'Kredi limiti', when: 'acentenin bir kredi limiti var', desc: 'Acentenin kısa vadeli kredisinden çekilir; daha sonra kredi koşullarına göre uzlaştırılır.' },
        { name: 'IPG bağlantısı', when: 'müşteri çevrimiçi öder', desc: 'Bir İran gateway’i (Shaparak / ZarinPal / IDPay…) aracılığıyla bir ödeme bağlantısı müşteriye gönderilir; gateway referansı dönüşte kaydedilir.' },
        { name: 'POS', when: 'gişede kart mevcut', desc: 'Şube kart okuyucusunda tahsil edilir; terminal ID, RRN ve iz numarası kanıt olarak girilir.' },
        { name: 'Banka havalesi (Sheba)', when: 'doğrudan IBAN yatırımı', desc: 'Kaynak ve hedef Sheba IBAN’ları artı havale referansı uzlaşma için kaydedilir.' },
      ],
    },
    related: ['flights-passengers', 'flights-ticket', 'counter', 'markup'],
  },

  'flights-ticket': {
    title: 'Uçuş Bileti',
    tag: 'Kesilmiş e-bilet',
    tagline: 'Kesilmiş e-bilet — PNR, yolcu, güzergâh ve acentenin satıştaki kârı.',
    business: {
      lead: 'Bilet sayfası satış kanıtıdır — yolcunun taşıdığı ve acentenin herhangi bir hizmet işlemi için başvurduğu PNR ve e-bilet numaraları. Ayrıca acenteye rezervasyondaki gerçekleşen marjı (satış − maliyet + komisyon) göstererek ticari döngüyü kapatır.',
      points: [
        { title: 'Yolcunun belgesi', desc: 'PNR ve bilet numarası, tam güzergâh, koltuk ve rezervasyon durumu tek yerde.' },
        { title: 'Hizmet burada başlar', desc: 'Güzergâhı e-postayla gönderin, referansı kopyalayın, rezervasyonu değiştirin veya hızlı eylemlerden bir iade başlatın.' },
        { title: 'Kâr gerçekleşir', desc: 'Finansal özet (satış, maliyet, kâr payı, komisyon, kâr) bu satıştaki marjı açıkça gösterir.' },
      ],
    },
    software: {
      lead: 'Uçuş, yolcu ve finansalların düzenlendiği voucher tarzı bir bilet.',
      points: [
        { title: 'Başlık ve yolcu bandı', desc: 'PNR, e-Bilet etiketi, yolcu adı, bilet numarası, sık uçan yolcu ve kesim zamanı.' },
        { title: 'Güzergâh ızgarası', desc: 'Uçuş numarası, uçak, kabin, ücret kademesi, kalkış / varış saatleri ve aktarmalar.' },
        { title: 'Finansallar ve eylemler', desc: 'Bir marj kenar çubuğu artı e-posta / kopyala / değiştir / iade kontrolleri.' },
      ],
    },
    related: ['flights-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  // ── Trains funnel (search → results → seats & pax → payment → ticket, + manual) ──
  'trains-results': {
    title: 'Tren Sonuçları',
    tag: 'Demiryolu arama',
    tagline: 'Gün için her kalkış, sıralanmış — rezerve edilecek treni ve sınıfı seçin.',
    business: {
      lead: 'Demiryolu sonuçları havadan daha istikrarlıdır: günün tarifesi ve ücretleri tutulur, böylece acente hareketli bir fiyatın peşinden koşmak yerine zaman, sınıf ve iade edilebilirlikte karşılaştırır. Her satır, sınıf seçenekleri ve kalan koltuklarıyla rezerve edilebilir bir kalkıştır.',
      points: [
        { title: 'Ücretler istikrarlıdır', desc: 'Aynı ücret genellikle işletme günü boyunca tutulur, böylece bir teklif bir uçuş ücretinden daha uzun süre geçerli kalır.' },
        { title: 'Taşıyıcıyı değil, sınıfı karşılaştır', desc: 'Karar rakip havayolları arasında değil, rotadaki vagon tipleri ve konfor arasındadır.' },
        { title: 'İade edilebilirlik önden', desc: 'Her satır, acente taahhüt etmeden önce iade edilebilir / kısmi / iade edilemez olarak etiketlenir.' },
      ],
    },
    software: {
      lead: 'Operatör, saatler, vagon tipi ve sınıf başına fiyat ile bir yolculuk listesi, artı bir ücret şeridi.',
      points: [
        { title: 'Günü filtrele', desc: 'Kenar çubuğu sıralamaya, tükenenleri gizlemeye, operatöre, fiyat histogramına, vagon tipine ve gün saati aralığına göre daraltır.' },
        { title: 'Ücret şeridini tara', desc: 'Bir ±7 günlük mini takvim tarih başına en ucuz fiyatı gösterir; yeniden aramak için tıklayın.' },
        { title: 'Bir kalkış seç', desc: 'Satırlar operatörü, saatleri, durakları, kalan koltukları ve iade etiketlerini gösterir; seçmek koltuklara ve yolculara ilerler.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'markup'],
  },

  'trains-manual': {
    title: 'Tren Manuel Giriş',
    tag: 'Kanal dışı bilet',
    tagline: 'Platform dışında rezerve edilen bir demiryolu biletini sipariş defterine kaydedin.',
    business: {
      lead: 'Bazı demiryolu biletleri doğrudan bir istasyonda veya bir operatör gişesinde satın alınır. Manuel giriş bunları aynı sipariş defterine getirir, böylece çevrimiçi demiryolu satışlarıyla birlikte izlenir, faturalandırılır ve raporlanır — hiçbir rezervasyon gözden kaçmaz.',
      points: [
        { title: 'Tek sipariş defteri', desc: 'Kanal dışı bir demiryolu bileti diğer herhangi bir sipariş gibi Tüm Rezervasyonlara katılır.' },
        { title: 'Marj yine raporlanır', desc: 'Ücret dökümü yakalanır, böylece kâr raporlaması eksiksiz kalır.' },
        { title: 'İstasyon düzeyi güzergâh', desc: 'Bacaklar istasyona göre girilir, demiryolunun gerçekte nasıl satıldığına uyar.' },
      ],
    },
    software: {
      lead: 'Demiryolu için girilen paylaşımlı ulaşım manuel giriş formu.',
      points: [
        { title: 'Yolculuğu gir', desc: 'İstasyonlar, operatör, saatler ve sınıf ile bacaklar.' },
        { title: 'Kaynak ve parayı ayarla', desc: 'Tedarikçi, para birimi ve bacak başına ücret dökümü.' },
        { title: 'Biletleri ata, sonra devam et', desc: 'Yolcu başına bir bilet; yolcu adımına devam edin.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'bookings'],
  },

  'trains-passengers': {
    title: 'Tren Koltukları & Yolcuları',
    tag: 'Sınıf, koltuk & yolcu',
    tagline: 'Sınıfı seçin, haritada vagon koltuklarını seçin ve yolcuları adlandırın.',
    business: {
      lead: 'Demiryolu, sınıf seçimini ve koltuk haritasını tek bir adımda birleştirir. Sınıf konforu ve dahil olanları belirler; vagon / koltuk haritası bileti fiziksel bir yere bağlar (birçok operatör cinsiyete duyarlı kompartımanları uygular); ve yolcu detayları rezervasyonu tamamlar.',
      points: [
        { title: 'Sınıf koldur', desc: 'Standart / Premier / Comfort fiyatı ayrıcalıklara karşı takas eder — acentenin demiryolundaki ana kararı.' },
        { title: 'Koltuk bileti bağlar', desc: 'Haritada bir vagon ve koltuk seçilir; rezerveli vs açık operatöre bağlıdır.' },
        { title: 'Havadan daha az belge alanı', desc: 'Demiryolu ad, iletişim ve sadakat ister — bir uçuşun gerektirdiği tam pasaport / APIS setini değil.' },
      ],
    },
    software: {
      lead: 'Bir sınıf seçici, interaktif bir vagon / koltuk haritası ve bir yolcu formu.',
      points: [
        { title: 'Sınıfı seç', desc: 'Kartlar seyahat sınıfı başına fiyat ve ayrıcalıkları karşılaştırır.' },
        { title: 'Vagon ve koltuk seç', desc: 'Vagonları değiştirin ve bir ızgarada (mevcut / dolu / seçilmiş) koltukları bir olanak açıklamasıyla seçin.' },
        { title: 'Yolcuları adlandır', desc: 'Yolcu başına unvan, ad, e-posta, telefon ve sadakat ID’si; ödemeye devam edin.' },
      ],
    },
    related: ['trains-results', 'trains-payment', 'customers'],
  },

  'trains-payment': {
    title: 'Tren Ödemesi',
    tag: 'Tahsil & kesim',
    tagline: 'Demiryolu rezervasyonunun nasıl ödeneceğini seçin, sonra bileti kesin — koltuk kilidi süresi dolmadan.',
    business: {
      lead: 'Ödeme, ücreti taahhüt eder ve demiryolu biletini keser. Koltuk seçimden sonra yalnızca kısa bir kilit penceresi için tutulduğundan, ödemeyi hemen tamamlamak onu güvence altına alan şeydir. Yöntem, fonların nasıl hareket edeceğine karar verir — cüzdan / kredi anında ya da acentenin kaydettiği bir gateway / POS / havale.',
      points: [
        { title: 'Koltuk bir sayaçtadır', desc: 'Seçim kısa bir tutma koyar; süresi dolmadan önce ödeyin, aksi halde koltuk serbest bırakılır.' },
        { title: 'Cüzdan ve kredi anındadır', desc: 'Her ikisi de anında kesim için acente hesabından çeker.' },
        { title: 'İran kanalları desteklenir', desc: 'IPG, POS ve Sheba banka havalesinin tümü cüzdan ve kredinin yanında mevcuttur.' },
      ],
    },
    software: {
      lead: 'Yönteme özel alanlar ve bir ödeme özeti olan bir ödeme yöntemi seçici.',
      points: [
        { title: 'Yöntemi seç', desc: 'Cüzdan, kredi, kart, IPG, POS veya Sheba havalesi.' },
        { title: 'Yöntemin formunu doldur', desc: 'IPG gateway + telefon + referans; POS terminal / RRN / iz; Sheba kaynak & hedef IBAN + referans.' },
        { title: 'Kilidi not et, sonra kes', desc: 'Bir koltuk kilidi afişi neyin tutulduğunu gösterir; “Öde ve kes” tahsil eder ve bilete geçer.' },
      ],
    },
    modes: {
      lead: 'Aynı ödeme yöntemleri ürünler genelinde mevcuttur — seçim, paranın nasıl ve ne zaman uzlaştığıyla ilgilidir.',
      modes: [
        { name: 'Cüzdan', when: 'varsayılan / önerilen', desc: 'Acentenin ön ödemeli bakiyesinden gerçek zamanlı olarak borçlandırılır. Kesime en hızlı yol.' },
        { name: 'Kredi limiti', when: 'acentenin bir kredi limiti var', desc: 'Kısa vadeli krediden çekilir; daha sonra koşullara göre uzlaştırılır.' },
        { name: 'IPG bağlantısı', when: 'müşteri çevrimiçi öder', desc: 'Bir gateway bağlantısı (Shaparak / ZarinPal…) müşteriye gönderilir; referans dönüşte kaydedilir.' },
        { name: 'POS', when: 'gişede kart mevcut', desc: 'Şube okuyucusunda tahsil edilir; terminal ID, RRN ve iz girilir.' },
        { name: 'Banka havalesi (Sheba)', when: 'doğrudan IBAN yatırımı', desc: 'Kaynak / hedef Sheba IBAN’ı ve havale referansı kaydedilir.' },
      ],
    },
    related: ['trains-passengers', 'trains-ticket', 'counter'],
  },
};
